import { render } from "./Widget14.vue?vue&type=template&id=34b187ff&ts=true"
import script from "./Widget14.vue?vue&type=script&lang=ts"
export * from "./Widget14.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__